import React from 'react';

import axios from 'axios';
import axiosUrl from '../../axios/url';

import InfiniteScroll from "react-infinite-scroll-component";


export default function DeliveryHistory(param) {

    const [userId, setUserId] = React.useState(0);
    const [projectId, setProjectId] = React.useState(0);
    const [programId, setProgramId] = React.useState(0);

    const [size, setSize] = React.useState(6);
    const [page, setPage] = React.useState(1);

    const [items, setItems] = React.useState([]);
    const [newItems, setNewItems] = React.useState([]);

    const [hasMoreItems, setHasMoreItems] = React.useState(true);


    // user목록 스크롤러 DB에서 값 읽어와서 추가하기
    const loadMoreItems = () => {
        if(hasMoreItems)  getDeliveryList(page, projectId, programId, userId, false);
    };

  // 사용자 목록 조회
  async function getDeliveryList(nextPage, pId, progId, userId, isInit){

    if(pId < 1 ) return;

    var url = axiosUrl.delivery_list + userId + '/deliveries?page=' + nextPage + '&size=' + size + 'sort=createdAt&order=desc';

    if(progId > 0){
        console.log('프로그램까지 검색 : ');
        console.log('=================================');
        await axios.post(url,{
            projectId : pId,
            programId : progId
        } )
        .then(function (response){
            const result = response.data;
            if(result.length< size )setHasMoreItems(false);
            if(JSON.stringify(result.data) === JSON.stringify(newItems)) return;
            
            return new Promise(resolve => {
                setTimeout(() => {
                    setHasMoreItems(true);
                    setNewItems(result);
                    setPage(nextPage+1);

                    if(isInit) setItems(result);
                    else setItems(items.concat(result));
                    console.log(result);

                     // 최초로 사용자 목록을 화면에 뿌릴때 모든 프로그램 목록 div를 hidden해야함.
                     //for(let i=0; i< result.length; i++){
                     //    console.log(i + '_history_' + result[i].id);
                     //    const obj = document.getElementById(i + '_history_' + result[i].id);
                     //    obj.className = 'd-none';
                     //}

                  resolve();

                }, 500);
              });
         })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] DeliveryHistory.getDeliveryList - ' + e.response.data.error.message);
        });
    }else{
        console.log('프로젝트까지 검색 : ');
        console.log('=================================');
        await axios.post(url,{
            projectId : pId
        } )
        .then(function (response){
            const result = response.data;
            console.log(result);
            if(result.length< size )setHasMoreItems(false);
            if(JSON.stringify(result.data) === JSON.stringify(newItems)) return;
            
            return new Promise(resolve => {
                setTimeout(() => {
                    setHasMoreItems(true);
                    setNewItems(result);
                    setPage(nextPage+1);

                    if(isInit) setItems(result);
                    else setItems(items.concat(result));

                     // 최초로 사용자 목록을 화면에 뿌릴때 모든 프로그램 목록 div를 hidden해야함.
                     // for(let i=0; i< result.length; i++){
                     //    console.log(i + '_history_' + result[i].id);
                     //    const obj = document.getElementById(i + '_history_' + result[i].id);
                     //    obj.className = 'd-none';
                     //}

                  resolve();

                }, 500);
              });
         })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] DeliveryHistory.getDeliveryList - ' + e.response.data.error.message);
        });
    }
    

    }

    function onClickDetail(objId){
        const obj = document.getElementById(objId);
        
        if(obj.className === 'd-none') {
            obj.className = 'd-block';
        }else{
            obj.className = 'd-none';
        } 
    }

    React.useEffect(() => {
        if(userId === param.userId && projectId === param.projectId && programId === param.programId) return;

        if(param.userId < 1){
            //초기화
            //setItems([]);
            //setNewItems([]);
            //setPage(1);
            return;
        }else{
            console.log('param.projectId : ' + param.projectId);
            console.log('param.userId : ' + param.userId);
            console.log('param.programId : ' + param.programId);
            console.log('param.programName : ' + param.programName);
            
            getDeliveryList(1, param.projectId, param.programId, param.userId, true);
            setUserId(param.userId);
            setProjectId(param.projectId);
            setProgramId(param.programId);
            document.getElementById('external-events2').scrollTop = 0;
        }
    });


    return(
        <div className="col-md-7">
        <div className="sticky-top mb-3">
            <div className="card">
                <div className="card-header  contentColor">
                    { param.userName === '' && <h4 className="card-title">발송이력</h4>}
                    { param.userName !== '' && <h4 className="card-title">{param.userName}님의 발송이력</h4>} <br />
                    <font className="text-danger float-left small">{param.programName}</font>
                </div>
                
                <div className="card-body">
                    <div id="external-events2" className="panel-group InfiniteHistoryList">
                    <InfiniteScroll
                        dataLength={items.length}
                        next={loadMoreItems}
                        hasMore={hasMoreItems}
                        // loader={<h4>Loading...</h4>}
                        scrollableTarget="external-events2"
                    >
                        {items.length <  1 && <div className="text-center">no data</div>}
                        {items.map((item, index) => (

                        <div className="border-dark border p-2 mb-5" key={index}>
                            <div className="">제목 :{item.scheduleItem.title}</div>
                            <div className="">내용 :{item.scheduleItem.body}</div>
                            <div className="">발송일자 :{item.createdAt}</div>
                            <div className="Detail_Link">프로그램 :{item.scheduleItem.tag.schedule.program.name} (<a onClick={() => onClickDetail(index+'_history_' + item.id)}>상세보기</a>)</div>
                            
                            <div className="d-none" id={index+'_history_' + item.id}>
                                <div className="DeliveryHistoryTagDiv mt-2 mb-2">
                                    <div className="DeliveryHistoryTagTitleDiv">태그</div>
                                    <div className="DeliveryHistoryTagBodyDiv">
                                        콘텐츠 : {item.scheduleItem.tag.tag}<br />  
                                        사용자 : {item.userTag.tags} 
                                    </div>
                                </div>
                                <div className="DeliveryHistoryTagDiv">
                                    <div className="DeliveryHistoryTagTitleDiv">스케줄</div>
                                    <div className="DeliveryHistoryTagBodyDiv">
                                        <div className="row">
                                            <div className="col-6">분류 : {item.scheduleItem.tag.schedule.classification}</div>
                                            <div className="col-6">형식 :{item.scheduleItem.tag.schedule.type}  </div>
                                        </div>
                                        {
                                            item.scheduleItem.tag.schedule.type === 'WEEK' && 
                                            <div>
                                                {item.scheduleItem.tag.schedule.week} 주차 / 
                                                    { item.scheduleItem.tag.schedule.weekday===1 && '월'} 
                                                    { item.scheduleItem.tag.schedule.weekday===2 && '화'} 
                                                    { item.scheduleItem.tag.schedule.weekday===3 && '수'} 
                                                    { item.scheduleItem.tag.schedule.weekday===4 && '목'} 
                                                    { item.scheduleItem.tag.schedule.weekday===5 && '금'} 
                                                    { item.scheduleItem.tag.schedule.weekday===6 && '토'} 
                                                    { item.scheduleItem.tag.schedule.weekday===7 && '일'} 
                                                    요일 / {item.scheduleItem.tag.schedule.hour}시 {item.scheduleItem.tag.schedule.minute}분
                                            </div>
                                        }
                                        {
                                            item.scheduleItem.tag.schedule.type === 'DAY' && 
                                            <div>
                                                {item.scheduleItem.tag.schedule.week} 주차 / {item.scheduleItem.tag.schedule.hour}시 {item.scheduleItem.tag.schedule.minute}분
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="">
                                시간 : {item.scheduleItem.tag.schedule.hour} : {item.scheduleItem.tag.schedule.minute} ,
                                예약일자 : {item.scheduleItem.tag.schedule.dateReserved}
                            </div>
                        </div>

                        ))}
                    </InfiniteScroll>

                    </div>
                </div>
            </div>
    
        </div>
    </div>

    );
}